import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getUsers: builder.query({
      providesTags: ["Users"],
      query: ({ page = 1, search = "", role = "", campus = "" } = {}) => {
        const params = { page };
        if (search?.trim()) params.search = search.trim();
        if (campus) params.campus = campus;
        if (role) params.role = role;
        return { url: "/user", method: "GET", params };
      },
    }),
    createUser: builder.mutation({
      query: (payload) => ({
        url: "/user",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Users"],
    }),
    updateUser: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/user/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Users"],
    }),
    updateUserAccountStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/user/updateprofilestatus/${id}`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["Users"],
    }),
    updateUserPicture: builder.mutation({
      query: (imageFile) => {
        const formData = new FormData();
        formData.append("image", imageFile);
        return {
          url: "/user/updatepicture",
          method: "PATCH",
          body: formData,
        };
      },
      invalidatesTags: ["Users"],
    }),
    adminUpdateUserPassword: builder.mutation({
      query: ({ id, password }) => ({
        url: `/user/adminupdatepassword/${id}`,
        method: "PATCH",
        body: { newPassword: password },
      }),
    }),
    getSingleUser: builder.query({
      query: (userId) => ({
        url: `/user/${userId}`,
        method: "GET",
      }),
    }),
    getCampusUsers: builder.query({
      providesTags: ["Users"],
      query: (campusId) => ({
        url: `/user/campus/${campusId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useUpdateUserAccountStatusMutation,
  useUpdateUserPictureMutation,
  useAdminUpdateUserPasswordMutation,
  useGetSingleUserQuery,
  useGetCampusUsersQuery,
} = userApi;
